import { bignum, COption } from "@metaplex-foundation/beet";
import { createCreateMarketInstruction } from "@metaplex-foundation/mpl-fixed-price-sale";
import { Wallet } from "wallet";
import { Keypair, PublicKey } from "@solana/web3.js";
import { TransactionsBatch } from "sdk/transactions";
import { toPubkey } from "sdk/share/toPubkey";

export interface CreateMarketTransactionProps {
  wallet: Wallet;
  store: PublicKey;
  sellingResource: PublicKey;
  mint: PublicKey;
  treasuryHolder: PublicKey;
  owner: PublicKey;
  treasuryOwnerBump: number;
  marketSettings: MarketSettings;
}

export interface MarketSettings {
  name: string;
  description: string;
  mutable: boolean;
  price: bignum;
  piecesInOneWallet: COption<bignum>;
  startDate: bignum;
  endDate: COption<bignum>;
  gatingTime?: number | null;
  gatingCollection?: string;
  expireOnUse?: boolean;
}

export const createMarketTransaction = ({
  store,
  wallet,
  sellingResource,
  mint,
  treasuryHolder,
  owner,
  treasuryOwnerBump,
  marketSettings,
}: CreateMarketTransactionProps) => {
  const market = Keypair.generate();

  const ix = createCreateMarketInstruction(
    {
      market: market.publicKey,
      store,
      sellingResourceOwner: wallet.publicKey,
      sellingResource,
      mint,
      treasuryHolder,
      owner,
      ...(marketSettings.gatingCollection
        ? { collectionMint: toPubkey(marketSettings.gatingCollection) }
        : {}),
    },
    {
      ...marketSettings,
      treasuryOwnerBump,
      gatingConfig: marketSettings.gatingCollection
        ? {
            collection: toPubkey(marketSettings.gatingCollection),
            expireOnUse: marketSettings.expireOnUse ?? false,
            gatingTime: marketSettings.gatingTime ?? null,
          }
        : null,
    }
  );

  const createMarketTx = new TransactionsBatch({
    instructions: [ix],
    signers: [market],
  });

  return {
    market,
    createMarketTx,
  };
};
